//
// arraysIdentical
//

import displayJson from './displayJson';

const arraysIdentical = (firstArray, secondArray, respectOrder, log = false) => {
  if ((respectOrder !== true) && (respectOrder !== false)) {
    throw new Error('arraysIdentical, respectOrder not defined');
  }

  if (log) {
    console.log(`arraysIdentical firstArray=${
      displayJson(firstArray)} secondArray=${
      displayJson(secondArray)} respectOrder=${
      respectOrder}`);
  }

  if (firstArray?.length !== secondArray?.length) {
    if (log) console.log('Lengths differ');
    return false;
  }

  if (respectOrder) {
    const ret = firstArray.every((entry, index) => (entry === secondArray[index]));

    if (log) console.log(`ret=${ret}`);
    return ret;
  }

  const secondIndexes = Array.from({ length: secondArray.length }, (value, index) => index);

  return firstArray.every((entry) => {
    const secondIndex = secondIndexes.findIndex((thisIndex) => (secondArray[thisIndex] === entry));

    if (secondIndex === -1) {
      if (log) console.log(`Cannot find "${entry}" in second array`);
      return false;
    }

    secondIndexes.splice(secondIndex, 1);
    return true;
  });
};

export default arraysIdentical;
